import { EventEmitter, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Router } from '@angular/router';
import { LeadTimeRule } from '../../shared/models/LeadTimeRule';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

@Component({
  selector: 'app-edit-lead-time-rule',
  templateUrl: './edit-lead-time-rule.component.html',
  styleUrl: './edit-lead-time-rule.component.css'
})
export class EditLeadTimeRuleComponent implements OnInit {
  @Output() CloseEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output() SaveRuleEmitter: EventEmitter<LeadTimeRule> = new EventEmitter();
  public CurrentRule: LeadTimeRule;
  public IsCreate: boolean;
  public CurUser: User;
  public constructor(private router:Router, private http:HttpService, private global:GlobalService) {
    //var currentState = router.getCurrentNavigation();
    //if (currentState.extras.state != null) {
    //  this.IsCreate = currentState.extras.state.isNew;
    //  if (currentState.extras.state.rule != null && this.IsCreate == false) {
    //    this.CurrentRule = <LeadTimeRule>currentState.extras.state.rule;
    //  } else {
    //    this.CurrentRule = new LeadTimeRule();
    //  }
    //}
  }


  ngOnInit() {
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
    });
  }

  SaveRule() {
    
    this.CurrentRule.UpdatedBy = this.CurUser.UserId.toString();    
    this.SaveRuleEmitter.emit(this.CurrentRule);
  }

  CloseWindow() {
    this.CloseEventEmitter.emit("");
  }

  SetExpirationDate(ev: MatDatepickerInputEvent<Date>) {
    this.CurrentRule.ExpirationDate = ev.value;
  }
}
